// منابع اعتباری بودجه
// جدول منابع اعتباری بین حسابداری و بودجه مشترک است؛ همان فرم را به کار می‌بریم
import React from 'react';
import AccountingCredit from '../Accounting/AccountingCredit';

export default function BudgetCredit({ user, onBack }) {
  return <AccountingCredit user={user} onBack={onBack} />;
}
